import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { ref: "selectedBonuses" }
const _hoisted_2 = {
  key: 0,
  class: "panel d-flex flex-column justify-content-center align-items-center"
}

import SelectedBonusesDisplay2 from "@/components/RegistrationPage/PcVersion/SelectedBonusesDisplay2.vue";
import PaymentInfo from "@/components/RegistrationPage/Payment/PaymentInfo.vue";

import { defineComponent } from 'vue'
import store from "@/store";
import {PassProperties} from "@/components/RegistrationPage/Card/PassProperties";

const __default__ = defineComponent({
    name: 'SelectedBonuses',

    data() {
        return {
            state: store.state,
        }
    },

    computed: {
        selectedPass(): PassProperties | null
        {
            return this.state.selectedPass
        },
    },

    watch: {
        selectedPass: {
            handler(): void
            {
                setTimeout(() => {
                    const el: HTMLDivElement = this.$refs.selectedBonuses as HTMLDivElement
                    el.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    })
                }, 100)
            },
        },
    },
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.selectedPass)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(PaymentInfo),
              (_ctx.state.canPurchase && _unref(store).state.canPurchase)
                ? (_openBlock(), _createBlock(SelectedBonusesDisplay2, { key: 0 }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}
}

})